import { useMemo, useEffect, useState } from 'react';
import { makeStyles, Grid, Typography } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { updateSettings } from '../../../../../../../store/actions/creator/analysis';
//import ScorePane from '../../../analysis/completed/graph/scorePane';
//import UtilService from '../../../../../../../helper/service';
//import CoreAnalysisBarGraph from '../../../analysis/completed/graph/bar';
//import CoreAnalysisLineBarGraph from '../../../analysis/completed/graph/linebar';
//import KnownOverviewLineBarGraph from './knownOverviewLinebar';
import LitIcon from '../../../../../../atoms/creator/litIcon';
import LitScoreCommentary from './litScoreCommentary';
import useWindowSize from '../../../../../../../helper/hooks/useWindowSize';
import ImmersionScore from './stats/immersion_score';
import SafetyColor from './stats/safety_color';
import ExperienceShape from './stats/experience_shape';
//import OverviewPill from './pills';

function LitScoreSection(props: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const { graphType, graphData, immersionData, confidenceScore, session } = props;
//console.log(`thumb is: ${thumbnailImage}`);
  const { currentSession, all, cliped, analyseStart, analyseEnd, stimulus, settings } = useSelector((state: any) => state.analysis);
  const { graphZoom, clip  } = settings;
  const { session_status, session_type } = currentSession;
  const [experienceLitResult, setExperienceLitResult] = useState({});
  

  const { width } = useWindowSize();
  const paneWidth = (width && width > 0 && width < 2000) ? width / 1.4 - 160 : 900;

  const graphLength = useMemo(() => {
    if (cliped && stimulus) return (cliped.end_clip - cliped.start_clip) + 1;
    if (stimulus && session_type === 'ASYNC') return stimulus.stimulus_video_length;
    if (cliped) return (cliped.end_clip - cliped.start_clip) + 1;
    return analyseEnd - analyseStart
  }, [stimulus, cliped, analyseEnd, analyseStart]);

  //console.log(graphZoom);
  const getMaxWidth = Math.floor(graphLength / Math.pow(graphZoom, 2) * 15);
  //const getMaxWidth = 900;

console.log(session_status);
console.log(graphType);
console.log(immersionData);
console.log(all);
console.log(getMaxWidth);
console.log(session_status);


  /*
  const graphs = all
    .filter((item: any) =>
      !excludedParticipants.includes(item.activeParticipant) &&
      (identifiers.includes(item.activeParticipant) || item.activeParticipant === 'All' || item.isTag)
    )
    .map((item: any) => (cliped ? {
      ...item, immersion: {
        ...item.immersion, data: item.immersion.data.filter((datum: any) => {
          return UtilService.getLocalEpoch2(datum.time_stamp) >= cliped.start_clip && UtilService.getLocalEpoch2(datum.time_stamp) <= cliped.end_clip
        })
      },
    } : item))
    .map((item: any) => (cliped ? {
      ...item, pills: item.pills.filter((datum: any) => {
        return (
          (cliped.start_clip <= datum.start && datum.start <= cliped.end_clip)
          || (cliped.start_clip <= datum.end && datum.end <= cliped.end_clip)
          || (datum.start <= cliped.start_clip && cliped.end_clip <= datum.end)
        )
      })
    } : item))
    .map((item: any) => (cliped ? {
      ...item, safety: item.safety.filter((datum: any) => {
        return datum.epoch_start + 120 >= cliped.start_clip && datum.epoch_start <= cliped.end_clip
      })
    } : item));
  
  */
  //  const graphData = graphs[0];

  if (!graphData) {
    return null
  }

//console.log(pdfLoading);

const getExperienceShape = (resultObj: any) => {
  setExperienceLitResult(resultObj);
  console.log(`LIT RESULT => ${resultObj.shape} ${resultObj.color} ${resultObj.score}`);
  console.log(experienceLitResult);
};



  useEffect(() => {
    if (analyseEnd && analyseStart && graphLength) {
      dispatch(updateSettings('graphZoom', Math.sqrt(graphLength * 15 / paneWidth)));
    }
  }, [analyseEnd, analyseStart, width, cliped, clip, stimulus]);

  return (
    <Grid item xs={12} >

    <Grid container alignContent={'center'} alignItems={'flex-start'} spacing={3}>
      <Grid item xs={5} style={{textAlign: 'right', display: 'flex', justifyContent: 'flex-end'}}>
        <LitIcon experiencedata={!!graphData ? graphData : {}} maxheight={'400px'} maxwidth={'400px'} fontsize={'220px'} scoretopbuffer={'40px'} callback={getExperienceShape}/>
      </Grid>
      <Grid item xs={5} >
      <Typography variant="h4" color={'primary'} className={classes.litscoreTitle} >{!!session ? session.session_title : 'Your Recent Experience'}</Typography>
      <Typography variant="body1" className={classes.categoryText} >{session && session?.session_category} / {session && session?.session_subcategory}</Typography>
      <LitScoreCommentary litObject={experienceLitResult} confidenceScore={confidenceScore} />
      
      </Grid>

      <Grid container direction={'column'} alignContent={'center'} alignItems={'center'} style={{ padding: 15, marginTop: '50px' }}>
      <Grid item xs={10}>
        
        <Grid container direction={'row'} spacing={3} >
     
      <ImmersionScore immersionData={immersionData}/>
      
      <SafetyColor litResult={experienceLitResult}/>
     
      <ExperienceShape litResult={experienceLitResult}/>
      
      </Grid>
      </Grid>
      </Grid>


    </Grid>






      

    </Grid>
  );
}

export default LitScoreSection;

const useStyles = makeStyles(() => ({
  container: {
    flex: 1,
    display: 'flex',
    //marginLeft: -310,
    //marginTop: -100,
  },
  litscoreTitle: {
    fontSize: 36,
    fontFamily: 'Spartan-bold',
    color: '#00000099',
    textAlign: 'left',
  },
  categoryText: {
    color: '#697683',
    fontFamily: 'roboto-light',
},
  immbox: {
    width: '100px', 
    background: '#00000099', 
    padding: '5px', 
    position: 'absolute', 
    display: 'block', 
    top: '-5px', 
    textAlign: 'center', 
    borderBottomRightRadius: '25%',
  },
  conbox: {
    width: '100px', 
    background: '#00000099', 
    padding: '5px', 
    position: 'absolute', 
    display: 'block', 
    top: '-5px', 
    right: '0px', 
    textAlign: 'center', 
    borderBottomLeftRadius: '25%',
  },
  boxScoreValue: {
    margin: '0px', 
    paddingTop: '10px',
    fontSize: '50px', 
    color: '#fff',
    fontFamily: 'Spartan-extrabold',
  },
  boxScoreLabel: {
    margin: '0px', 
    fontSize: '10px', 
    color: '#fff'
  },
  graphSection: {
    flex: 1,
    flexDirection: 'column',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    overflow: 'hidden',
    scrollbarWidth: 'none',
    //marginRight: -310,
  },
 
  pane: {
    position: 'absolute',
  },
}));